import type {
  AuthorRelationResponseCollection,
  ComponentCommonAuthorDetailed,
  Resource,
  ResourceEntity,
} from '@edwin-group/cj-graphql/generated/graphql';

export function getAuthors(resource?: Resource | ResourceEntity) {
  const authors = resource?.attributes?.DefaultContentTemplate?.filter(
    (component) => component?.__typename === 'ComponentCommonAuthorDetailed',
  ).map((component: unknown) => {
    return ((component as ComponentCommonAuthorDetailed)?.authors as unknown as AuthorRelationResponseCollection)?.data
      .map((author) => author.attributes?.name)
      .join(', ');
  });

  return authors?.flatMap((author) => author).join(' ') || '';
}
